import { createTheme } from "@mui/material";
import { makeStyles } from '@mui/styles';

export const theme = createTheme(
    {
        typography: {
            allVariants: {
                fontFamily: `'Be Vietnam Pro', sans-serif`
            },
        },
        palette: {
            primary: { main: '#DC8449' },
            error: { main: '#A70100' },
        },
        shape: {
            borderRadius: 10,
        },
    },
);



export const useStyles = makeStyles({

    root: {
        "& .MuiDataGrid-renderingZone": {
            // maxHeight: "none !important"
        },
        "& .MuiDataGrid-cell": {
            lineHeight: "unset !important",
            maxHeight: "300px !important",
            // whiteSpace: "normal"
        },
        "& .MuiDataGrid-row": {
            maxHeight: "300px !important"
        },
        "&.MuiDataGrid-columnsContainer": {
            background: '#010310',
        },

    }
});
